<template>
    <div class="fwht">
        <div class="fwhtcontent">
            <div v-show="fujianlist.length">
                下载附件：
            </div>
            <div class="imgrq" v-for="(item,index) in fujianlist" :key="index">
                <div v-if="!ios" @click="downloadFile(item)">{{item.name}}</div>
                <button v-else @click="copy" v-clipboard:copy="'https://zhwy.zjj.suqian.gov.cn'+item.src" v-clipboard:success="copy" >点击复制{{item.name}}的下载链接</button>
            </div>
            <div class="imgrq" v-for="(item,index) in img" :key="index">
                <img :src="'https://zhwy.zjj.suqian.gov.cn'+item.webUrl" alt="" @click="showimg()">
            </div>
        </div>
    </div>
</template>
<script>
	import Vue from 'vue';
	import { Image as VanImage ,ImagePreview } from 'vant';
	Vue.use(VanImage);
	Vue.use(ImagePreview);
import {
		mapState,
		mapMutations
	} from "vuex";
export default {
    data() {
        return {
            fujianlist:[],
            img:[],
            ios:false,
        }
    },
	computed: {
		...mapState(['userInfo', 'identity', 'houseId']),
	},
    mounted() {
        this.$axios.get('/api/v1/wygl/servicecontract/view', {
        	params: {
        		houseId: this.houseId,
				pageNum:0,
				pageSize:10
        	}
        }).then(res => {
            var fjlist = []
            res.data.forEach(item=>{
                if(item.webUrl.indexOf('/api/v1/common/download/') != -1){
                    fjlist.push(item)
                }else{
                    this.img.push(item)
                }
                if(fjlist.length != 0 ){
                    this.fujianlist = fjlist.map((fujian,index)=>{
                        return {
                            name:'附件'+(index+1),
                            src:fujian.webUrl
                        }
                    })
                }
                
            })
        });
        let u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;  //安卓终端
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);                //苹果终端 
        if(isAndroid){
            this.ios = false
        }
        if(isIOS){
            this.ios = true
        }
    },
    methods: {
        showimg(){
            var that = this
            ImagePreview({
                images: that.img.map(item=>{
                    return item.webUrl
                }),
                closeable: true,
            });
        },
        downloadFile(item) {
            this.download(item.src, item.name);
        },
        copy(){
            this.$toast.success('复制成功')
        },
        download (src, fileName) {
            let x = new XMLHttpRequest();
            x.open("GET", src, true);
            x.responseType = 'blob';
            x.onload = function(e) {
                let a = document.createElement('a');
                a.href = 'https://zhwy.zjj.suqian.gov.cn' + src
                a.download = fileName
                a.click()
            }
            x.send();
        },
    },
}
</script>
<style lang="less" scoped>
    .fwht{
        padding: 20px;
        box-sizing: border-box;
        .fwhtcontent{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .title{
                font-size: 20px;
                font-weight: bold;
            }
            p{
                margin: 0;
                padding: 0;
                text-indent: 2rem;
                line-height: 30px;
                font-size: 15px;
            }
            .imgrq{
                width: 100%;
                button{
                    margin-top: 20px;
                }
            }
			img{
                height: 200px;
				width: 100%;
			}
        }
    }
</style>